// extracted by mini-css-extract-plugin
module.exports = {"authScreen":"Auth_authScreen__2_sk9","authContainer":"Auth_authContainer__16ztz"};